import { Dictionary } from 'environment';
import type { Action } from 'types/store/types';

export interface State {
	translations: typeof Dictionary | null;
}

export enum ActionTypes {
	GET_LANGUAGE = 'ui/i18n/GET_LANGUAGE'
}

export type GetLanguageAction = Action<
	ActionTypes.GET_LANGUAGE,
	{
		translations: typeof Dictionary;
	}
>;

export type Actions = GetLanguageAction;
